import { render, staticRenderFns } from "./SearchProviderAutocompleteSingleItem.vue?vue&type=template&id=54a40524"
import script from "./SearchProviderAutocompleteSingleItem.vue?vue&type=script&lang=js"
export * from "./SearchProviderAutocompleteSingleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports